import { createReducer, on } from '@ngrx/store';
import counterAction from './requestCounter.action';

export { counterAction as actions };

export * from './requestCounter.selectors';

const REQUEST_COUNTER_STARTING_VALUE = 0;
const REQUEST_COUNTER_STEP_VALUE = 1;

export interface State {
  requestCounter: number;
}

export const initialState: State = {
  requestCounter: REQUEST_COUNTER_STARTING_VALUE,
};

export const reducer = createReducer(
  initialState,
  on(counterAction.incrementCounter, (state) => ({ ...state, requestCounter: state.requestCounter + REQUEST_COUNTER_STEP_VALUE })),
  on(counterAction.decrementCounter, (state) => ({ ...state, requestCounter: state.requestCounter - REQUEST_COUNTER_STEP_VALUE })),
);
